export const DISABILITY_ENUM = [
	"other",
	"mobility",
	"intellectual",
	"emotional_disorders",
	"hearing",
	"visual",
	"down_syndrome",
	"physical",
	"autism",
	"learning_difficulties",
	"behavioral_disorders",
	"speech_difficulties",
	"sickle_cell_anemia",
	"hemophilia",
	"multiple_sclerosis",
	"heart_diseases",
	"kidney_failure",
] as const

export const LEVEL = ["no_experience", "weak", "medium", "advanced"] as const
export const JOB_TYPE = ["full_time", "part_time", "remote"] as const
export const DEGREE_FIELD = [
	"economics_and_administration",
	"islamic_economics",
	"arts_and_humanities",
	"english_language",
	"science",
	"engineering",
	"architecture_and_planning",
	"medicine",
	"applied_sciences",
	"earth_sciences",
	"marine_sciences",
	"law",
	"environmental_sciences",
	"pharmacy",
	"tourism",
	"human_sciences_and_design",
	"education",
	"communication_and_media",
	"computing_and_information_technology",
	"nursing",
	"other",
] as const

export const DEGREE_NAME = [
	"highschool",
	"diploma",
	"bachelor",
	"master",
	"phd",
] as const

export const HEAR_ABOUT = ["friend", "aspd", "social_media", "other"] as const
export const USER_TYPE = [
	"organization",
	"employee",
	"semi_admin",
	"admin",
] as const
export const MARITAL_STATUS = ["single", "married"] as const
export const GENDER = ["male", "female"] as const
export const TIMINGS = ["morning", "evening", "period"] as const
export const WORK_ENVIRONMENT = [
	"calm_environment",
	"requires_mobility",
	"cold_environment",
	"signlesex_environment",
	"office_environment",
] as const

export const ORGANIZATION_SIZE = ["small", "medium", "large", "huge"] as const
export const ORGANIZATION_SECTOR = [
	"private",
	"government",
	"non_profit",
] as const
export const CONVERSATION_TYPE = ["contact_us"] as const
export const MESSAGE_SENDER = ["user", "staff"] as const

/** Job "مخصصة الى" / targeted to: Saudi nationals, non-Saudi, or both */
export const TARGETED_TO = ["saudi", "non_saudi", "both"] as const
